import { useRouter } from '#imports';
import { resolveRenewalHref } from '~~/package/config/renewalLinkMap';

/**
 * renewal 마크업 안의 링크를 위임으로 받아, 우리 앱 경로면 라우터로 보낸다.
 *
 * href 를 고쳐 쓰지 않는 이유: renewal 은 단독 사이트로도 서비스되고, 거기에는
 * `/home/contact` 가 없다. 절대 URL 을 상대경로로 바꾸면 그쪽이 깨진다. 그래서
 * DOM 은 그대로 두고 클릭만 가로챈다 — 새 탭·우클릭 복사에서는 절대 URL 이
 * 계속 제대로 동작한다.
 *
 * 콘텐츠(RenewalContent)와 헤더의 GNB 양쪽이 같은 규칙을 쓰도록 한곳에 둔다.
 */
export const useRenewalLinkInterception = () => {
    const router = useRouter();

    return (event: MouseEvent) => {
        if (event.defaultPrevented) return;
        // 보조키·가운데 클릭은 사용자가 새 탭을 의도한 것이므로 브라우저에 맡긴다.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const anchor = (event.target as HTMLElement | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
        if (!anchor || anchor.hasAttribute('download')) return;

        const resolved = resolveRenewalHref(anchor.getAttribute('href'), window.location.origin);
        if (resolved.kind !== 'internal') return;

        event.preventDefault();
        // 마크업이 새 탭을 의도했다면 그 의도는 지키되, 목적지는 우리 앱 경로로 연다.
        // 그래야 dev·stage 에서 운영 도메인으로 튕기지 않는다.
        if (anchor.target === '_blank') {
            window.open(resolved.path, '_blank', 'noopener');
            return;
        }
        router.push(resolved.path);
    };
};
